import { render, staticRenderFns } from "./submit-success.vue?vue&type=template&id=407132ca&scoped=true"
import script from "./submit-success.vue?vue&type=script&lang=ts"
export * from "./submit-success.vue?vue&type=script&lang=ts"
import style0 from "./submit-success.vue?vue&type=style&index=0&id=407132ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407132ca",
  null
  
)

export default component.exports